import React from "react";
import styled from "styled-components";

export interface SvgIconProps extends Omit<React.SVGProps<SVGSVGElement>, "ref"> {
    children?: React.ReactNode;
    size?: number | string;
    color?: string;
}

const SvgIconRoot = styled.svg<SvgIconProps>`
    width: ${({ size }) => (typeof size === "number" ? `${size}px` : size || "1.5rem")};
    height: ${({ size }) => (typeof size === "number" ? `${size}px` : size || "1.5rem")};
    fill: ${({ color, theme }) => color || theme.palette.text};
    display: inline-block;
    overflow: visible;
    flex-shrink: 0;
`;

export const SvgIcon: React.FC<SvgIconProps> = ({ children, size, color, viewBox = "0 0 24 24", ...props }) => {
    return (
        <SvgIconRoot size={size} color={color} viewBox={viewBox} {...props}>
            {children}
        </SvgIconRoot>
    );
};

export default SvgIcon;


